module.exports = __webpack_public_path__ + "img/dragon-shield-data.b06cf980.png";